export enum ClientTypes {
    International = 1,
    Domestic,
}

export const ClientTypesMap = {
    [ClientTypes.International]: 'International',
    [ClientTypes.Domestic]: 'Domestic',
};
